<template>
  <div id="app1" class="hello">
    <div class="content-center-row login-info f-15" style="display:flex;justify-content: space-between;">
      <div style="line-height: 40px;white-space: nowrap;" class="top_left">
          <span class="el-dropdown-link span-line pointer top_header" @click="return_index">
            Hello，
            <span v-if="this.$store.state.currentUser != ''">{{title}}</span>
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
          </span>
        <span
          style="background-color: #F5F5F5;border: none;color: #409EFF;margin: 10px;font-size: 14px;"
          class="pointer"
          @click="go_login"
          round
          v-if="this.$store.state.currentUser == ''"
        >登录</span>|
        <span
          v-if="this.$store.state.currentUser != ''"
          style="background-color: #F5F5F5;border: none;color: #409EFF;margin: 10px;font-size: 14px;"
          class="pointer"
          @click="logout"
          round
        >退出登录</span>
      </div>
      <div class="top_right">
        <div class="content-row f-15" style="margin: 0.5%;">
          <span @click="gotoMyOrder()" style="cursor:pointer;margin-right:10px">我的订单</span>|
          <!-- <span
            @mouseover="show_wx()"
            @mouseout="hide_wx()"
            style="cursor:pointer;margin-left:10px"ldldldksksk
          >公众号</span>-->
          <el-popover placement="top-start" width="100" trigger="hover">
            <el-image src="static/image/wx.jpg" style="height:200px;width:200px"></el-image>
            <span style="cursor:pointer;margin-left:10px" slot="reference">旭欧官方公众号</span>
          </el-popover>
          <!-- onmouseout -->
        </div>
      </div>
    </div>
    <div class="content-row header">
      <div class="content-center-row" style="margin-bottom: 8px;">
        <div class="col-6">
          <img class="logo-img" src="static/image/logs.png" />
        </div>
        <div class="col-5" style="display:flex;justify-content: flex-end;">
          <div class="div-left">
            <div data-v-02920316 class="el-input el-input--suffix">
              <input
                type="text"
                autocomplete="off"
                placeholder="请输入商品名称/商品型号"
                class="el-input__inner"
                v-model="searchKeywords"
                @keyup.enter="searchGood()"
              />
              <!-- @keyup.enter.native="searchGood()" -->
              <span class="el-input__suffix" style="right:1.5px">
                <span class="el-input__suffix-inner pointer">
                  <el-button class="search" @click="searchGood()" round>搜索</el-button>
                  <!-- <i data-v-02920316 class="el-input__icon el-icon-search" @click="searchGood()"></i> -->
                </span>
              </span>
            </div>
            <!-- <el-input
              placeholder="请输入要搜索的商品名称"
              v-model="searchKeywords"
              @keyup.enter.native="searchGood()"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="searchGood()"></i>
            </el-input>-->
          </div>
          <div class="div-right">
            <span class="span-cart">
              <el-badge
                v-if="this.$store.state.currentUser != ''"
                :value="this.$store.state.currentQty == 0 ? '' : this.$store.state.currentQty"
                :max="99"
                class
              >
                <span class="span-carts f-14-gray" @click="gotoCart()">
                  <i
                    class="fa fa-shopping-cart button-icon"
                    style="margin:10% 0"
                    aria-hidden="true"
                  ></i>购物车
                </span>
              </el-badge>
              <span class="span-carts f-14-gray" @click="gotoCart()" v-else>
                <i class="fa fa-shopping-cart button-icon" style="margin:10% 0" aria-hidden="true"></i>购物车
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="nav-ul row-menu">
        <div class="item-nav-ul"></div>
        <div class="item-nav-ul-list">
          <div class="content-row">
            <div class="div-menu">
              <ul class="left-menu">
                <li
                  v-for="(item,index) in data"
                  :key="index"
                  @click="jumpPage(item.url,index)"
                  :class=" item.menu == 1 ? 'menu-li first-li' : 'menu-li'"
                >
                  <span
                    style="margin-left:-38px;"
                    @mouseenter="showChildMenu($event,index)"
                    @mouseleave="hideChildMenu($event,index)"
                  >
                    <i v-if="index == 0" class="fa fa-bars" aria-hidden="true"></i>
                    {{item.name}}
                  </span>
                  <ul v-if="item.child != null" class="detail-menu out" @mouseleave="hideSecondMenu">
                <li
                  v-for="(items,index) in item.child"
                  :key="items.good_cate_itemid"
                  @mouseenter="showLevel2Menu($event,index)"
                  @mouseleave="hideLevel2Menu($event,index)"
                  @click="jump_cate(items.good_cate_itemid)"
                >
                  <span style="color:#000;">{{items.good_cate_name}}</span>
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                  <ul class="level2menu out">
                    <li
                      style="color:#000;"
                      v-for="item_second in items.child"
                      @click.stop="gotoLevel2HomePage(item_second.good_cate_itemid)"
                      :key="item_second.good_cate_itemid"
                    >{{item_second.good_cate_name}}</li>
                  </ul>
                </li>
              </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item-nav-ul">

        </div>
      </div>
    </div>
    <div class="content-row">
      <div class="body-content"></div>
    </div>
  </div>
</template>

<script>
import { debuglog } from "util";
import Vue from "vue";
import Unit from "@/assets/js/Unit";
import ElementUI from "element-ui";
Vue.use(ElementUI);

export default {
  name: "mainMenu",
  components: { ElementUI },
  data() {
    return {
      data: [],
      tabIndex: 1,
      Tabs: [],
      TabsValue: "",
      CartNum: "",
      searchKeywords: "",
      custom_name: "",
      centerDialogVisible: false,
      title: ""
    };
  },

  mounted() {
    this.view();
  },
  watch: {
    // CartNum: function() {
    //   setInterval(() => {
    //     this.getCartNum();
    //   }, 2000);
    // }
  },
  methods: {
    //列表标题
    view() {
      // if (this.$route.path != "/") {
      //   this.$router.push({
      //     path: "/"
      //   });
      // }
      this.$axios({
        method: "post",
        url: "/index/Catalogue/cate_tree"
      })
        .then(res => {
          this.data = res.data.data;
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/customer/get_register_info"
      })
        .then(res => {
          this.title = res.data.data.invoices.title;
        })
        .catch(err => {});
      this.getLoginInfo();
      this.getCartNum();
    },
    getLoginInfo() {
      this.$axios({
        method: "post",
        url: "/index/index/check"
      })
        .then(res => {
          this.custom_name = res.data.data.custom_name;
        })
        .catch(err => {});
    },
    // searchGood() {
    //   this.$router.replace({
    //     path: "/Level2HomePage/index",
    //     query: { keyword: this.searchKeywords }
    //   });
    // },
    notice_detail(status, item) {
      this.$router.push({
        path: "/Customized/index",
        query: { status: status, item: item }
      });
    },
    showLoginOut() {
      if ($(".login-out").hasClass("hide")) {
        $(".login-out").removeClass("hide");
      } else {
        $(".login-out").addClass("hide");
      }
    },
    showServiceInfo() {
      $(".kf-div").removeClass("hide");
    },
    showChildMenu(event, index) {
      if ($(".detail-menu:eq(" + index + ")").hasClass("out")) {
        $(".detail-menu:eq(" + index + ")").removeClass("out");
        $(".detail-menu:eq(" + index + ")").fadeIn();
      } else {
        // event.currentTarget.lastChild.classList.add("out")
      }
    },
    hideChildMenu(event, index) {
      if (!$(".detail-menu:eq(" + index + ")").hasClass("out")) {
        // $(".detail-menu:eq(" + index + ")").addClass("out");
        // $(".detail-menu:eq(" + index + ")").fadeOut();
        // event.currentTarget.parentNode.children[3].classList.remove("in");
      } else {
        //event.currentTarget.lastChild.classList.add("out")
      }
    },
    showLevel2Menu(event, index) {
      if ($(".level2menu:eq(" + index + ")").hasClass("out")) {
        $(".level2menu:eq(" + index + ")").removeClass("out");
      } else {
      }
    },
    hideLevel2Menu(event, index) {
      if (!$(".level2menu:eq(" + index + ")").hasClass("out")) {
        $(".level2menu:eq(" + index + ")").addClass("out");
      } else {
      }
    },
    jump_cate(e) {
      this.$router.push({
        path: "/Level2HomePage/index",
        query: { level_id: e }
      });
    },
    logout() {
      this.$axios({
        method: "post",
        url: "/index/login/out"
      })
        .then(res => {
          if (res.data.status == "ok") {
            sessionStorage.setItem("user", "");
            this.$router.push({
              path: "/login/index"
            });
            // window.location.reload();
          }
        })
        .catch(err => {});
    },
    gotoLevel2HomePage(good_cate_itemid, good_cate_itemid1) {
      $(".detail-menu").addClass("out");
      this.$router.push({
        path: "/Level2HomePage/index",
        query: { level_id: good_cate_itemid, id: good_cate_itemid1 }
      });
    },
    gotoMyOrder() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      this.$router.replace({
        path: "/Personal/index",
        query: { page_name: "我的订单", menu_id: 2 }
      });
    },
    searchGood() {
      if (this.$route.path == "/Level2HomePage/index") {
        Unit.$emit("searchGood", this.searchKeywords);
      } else {
        this.$router.replace({
          path: "/Level2HomePage/index",
          query: { keyword: this.searchKeywords }
        });
      }
    },
    gotoCart() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      this.$router.replace({ path: "/Cart/index" });
    },
    getCartNum() {
      this.$axios({
        method: "post",
        url: "/index/cart/get_qty"
        //  params: {data: []},  // data
        //  headers:"json"
      })
        .then(res => {
          this.CartNum = res.data.data;

          this.$store.dispatch("setQty", res.data.data);
          sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
        })
        .catch(err => {});
    },
    return_index() {
      this.$router.replace({
        path: "/"
      });
    },
    go_login() {
      this.$router.replace({
        path: "/login/index"
      });
    },
    //  addCount(){
    //   this.$store.commit('addCount',1)
    // },

    hideSecondMenu() {
      $(".detail-menu").addClass("out");
    },
    show_wx() {
      this.centerDialogVisible = true;
    },
    hide_wx() {
      // this.centerDialogVisible = false;
    },
    jumpPage(url, index) {
      if (index == 0) {
        return;
      }
      if (index == 3) {
        if (this.$store.state.currentUser == "") {
          this.$message1("当前未登录，请登录！");
          return;
        }
      }
      if (index == 5) {
        if (this.$store.state.currentUser == "") {
          this.$message1("当前未登录，请登录！");
          return;
        }
        Unit.$emit("closeMenu", "1");
      }
      if (url == "Customized") {
        $(".menu-li").removeClass("menu-active");
        $(".menu-li:eq(" + index + ")").addClass("menu-active");
        if (this.$route.path == "/Customized/index") {
          window.location.reload();
        } else {
          this.$router.replace({
            path: "/Customized/index",
            query: { page_name: "我的订单", menu_id: 1 }
          });
        }
        return;
      }
      if (url == "Orders") {
        $(".menu-li").removeClass("menu-active");
        $(".menu-li:eq(" + index + ")").addClass("menu-active");
        this.$router.replace({
          path: "/Personal/index",
          query: { page_name: "我的订单", menu_id: 1 }
        });
        return;
      }
      if (url == "Personal") {
        $(".menu-li").removeClass("menu-active");
        $(".menu-li:eq(" + index + ")").addClass("menu-active");
        this.$router.replace({
          path: "/Personal/index",
          query: { page_name: "个人中心", menu_id: 1 }
        });
        return;
      }
      $(".menu-li").removeClass("menu-active");
      $(".menu-li:eq(" + index + ")").addClass("menu-active");
      if (url == "HomePage") {
        this.$router.replace({ path: "/" });
      } else {
        this.$router.replace({ path: "/" + url + "/index" });
      }
    }
  },

  loginOut() {}
};
</script>
<style scoped lang="less">
#app1 {
  width: 100%;
  height: 100%;
}
.left-menu {
  list-style-type: none;
  width: 100%;
  margin: 0 auto;
  margin-left: 16.8%;
}
.first-li {
  text-align: left;
  background-color: #c39a58;
  color: #fff;
  width: 175px !important;
}
.span-line:hover {
  text-decoration: underline;
  color: rgb(64, 158, 255);
}
.first-li i {
  // margin: 10%;
  padding: 0 10%;
  margin-top: 0;
}
.first-li span {
  // display: flex;
}
.menu-active {
  color: #c39a58 !important;
}
.top_right{
  line-height: 3;
  margin-right: 8.5%;
}
.fa-angle-right {
  display: inline-block;
}
.rotate {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -webkit-transition: -webkit-transform 0.1s linear;
  transition: transform 0.3s linear;
}
.rotate1 {
  transform: rotate(90%);
  -webkit-transition: -webkit-transform 0.5s linear;
  transition: transform 0.3s linear;
}
i {
  width: 16px;
  height: 16px;
  // margin: 10%;
}
.login-info {
  background-color: whitesmoke;
  height: 2.5rem;
  line-height: 2.5;
}
h3 {
  color: darkgray;
  font-weight: 600;
  text-align-last: justify;
  margin-top: -15%;
}
.left-menu li {
  width: 8%;
  font-size: 14px;
  float: left;
  line-height: 2.5;
  height: 35px;
  cursor: pointer;
  color: #fff;
  text-align: center;
}
.btn-primary {
  background: #fff;
}
.active {
  display: inline-block;
  background-color: #247dcd;
  color: #d7e445;
  border-left: 3px solid #4fb9bb;
  width: 98% !important;
}
.detail-menu {
  width:175px;
  background-color: #fff;
  -moz-box-shadow: 2px 5px 5px #bdbdbd;
  -webkit-box-shadow: 2px 5px 5px #bdbdbd;
  box-shadow: 2px 5px 5px #bdbdbd;
  padding-left:0;
  // margin-top: -1%;
  z-index: 99;
  position: absolute;
}

.detail-menu>li {
  position: relative;
  float: unset;
  width:100%;
  text-align:center;
  list-style-type: none;
}
.detail-menu a {
  text-decoration: none;
  color: #000;
}
.in {
  display: block;
}
.out {
  display: none;
}
.div-menu {
  height: 100%;
}
.div-top {
  background: #fff;
  width: 100%;
  margin-left: 1%;
  // calc(100% - 200px);
  height: 65px;
  border-bottom: 1px solid lightgrey;
}
.img {
  float: left;
  margin: 0 2% 0 5%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.top-left {
  width: 40%;
  float: left;
  margin-top: 5px;
}
.top-left span {
  float: left;
  padding: 3% 0 0 1%;
  color: #247dcd;
  font-weight: 500;
}
.top-right {
  height: 100%;
}
.top-right i {
  font-size: 18px;
  color: darkgray;
}
.top-right span {
  margin: 5% 0 0 2%;
  font-size: 14px;
  color: darkgray;
}
.top-right-div {
  width: 100%;
  text-align: right;
  line-height: 4;
}
.top-right-div span {
  margin: 2% 0 0 2%;
}
.top-right-div i {
  margin: 2%;
}
.div-top-menu {
  width: 100%;
  margin-left: 1%;
  height: 40px;
  // box-shadow: 0 5px 20px lightgray;
  border-bottom: 1px solid whitesmoke;
  background: #fff;
}
.div-top-menu i {
  font-size: 24px;
  color: darkgray;
}
.left-icon {
  float: left;
  height: 100%;
  width: 100px;
}
.left-menu-content {
  float: left;
  margin-top: 0.2%;
  width: calc(100% - 200px);
}
.left-icon span {
  float: left;
  width: 45%;
  text-align: center;
  margin: 5% 3% 0 0;
  cursor: pointer;
}
.J_menuTabs {
  margin: 6% 0 0 20%;
}
.right-icon {
  float: right;
  margin-top: -2%;
  padding-right: 1%;
}
.hr {
  width: 1px;
  height: 40px;
  border: 0.5px solid gainsboro;
  float: left;
}
.div-content {
  width: calc(100% - 200px);
  float: left;
}
.el-tabs__nav-wrap {
  margin: 1% 0 1% 1%;
  height: 35px;
}
.el-tabs__nav-scroll {
  margin-top: 0.5% !important;
  margin-bottom: -1%;
}
.el-tabs--card > .el-tabs__header {
  border-bottom: none;
}
.is-closable {
  margin-left: 2%;
  background-color: #2d8de4;
  border-radius: 50%;
}
.el-tabs__item.is-active {
  background-color: #d7e445;
}
.J_iframe #app1 {
  display: none;
}
.menu-li {
  cursor: pointer;
}
.body-content {
  // float: left;
  // background: lightgray;
  overflow: hidden;
  height: 100%;
  width: 80%;
}

.header {
  background-color: #fff;
}
.div-left {
  text-align: right;
  height: 100%;
  width: 50%;
  margin-top: 2.5%;
}
.div-right {
  float: left;
  height: 100%;
  margin-top: 2%;
}
.el-input__inner {
  border-radius: 20px;
  border: 1px solid #464646;
}
.span-cart {
  border-radius: 30px;
  padding: 5% 0% 0 0;
  // margin: 24% 0 0 5%;
  float: left;
  cursor: pointer;
}
.span-carts {
  display: inline-block;
  width: 85px;
  border: 1px solid #a8a8a8;
  border-radius: 20px;
  height: 2.25rem;
  line-height: 2.25rem;
}
.content-row {
  margin-bottom: 0;
}
.row-menu {
  // border-bottom: 3px solid #2d8de4;
  background-color: #111111;
  margin-top: 0.8%;
}
.footer {
  bottom: 0;
  position: absolute;
  height: 5rem;
  background-color: whitesmoke;
  z-index: 99;
}
.footer-menu {
  width: 100%;
  list-style-type: none;
  float: left;
  margin-left: 20%;
  position: absolute;
  z-index: 10;
}
.footer-menu li {
  text-align: left;
  width: 10%;
  font-size: 15px;
  float: left;
  cursor: pointer;
  font-weight: 800;
  margin-left: 1%;
  margin-top: 0.2%;
}
.footer-menu span {
  color: darkgray;
}
.footer-menu img {
  float: left;
}
.logo-img {
  margin-right: 34%;
  width: 15%;
  margin-top: 2%;
}
.fa-angle-right {
  float: right;
  margin-top: 10px !important;
}
.level2menu {
  list-style: none;
  width:200px;
  height: auto;
  position: absolute;
  top:0;
  margin-left: 175px;
  z-index: 9999;
  color: #000;
  background: #fff;
  border-left:1px solid #eee;
  -moz-box-shadow: 2px 5px 5px #bdbdbd;
  -webkit-box-shadow: 2px 5px 5px #bdbdbd;
  box-shadow: 2px 5px 5px #bdbdbd;
  padding: 0;
  line-height: 1.5;
}
.level2menu li {
  width:auto;
  float:unset;
  text-align: center;
  padding: 0 15px;
  font-size: 14px;
}
.login-out {
  position: absolute;
  float: left;
  z-index: 2009;
  /* margin: 0 auto; */
  margin-left: 19%;
  background-color: whitesmoke;
  cursor: pointer;
  width: 6rem;
  padding-left: 1%;
  border-top: 2px solid lightslategrey;
  margin-top: 0.4%;
}
.el-dropdown-menu a {
  color: #409eff;
  text-decoration: none;
}
.span-user {
  margin-left: 38%;
  cursor: pointer;
}
.el-icon-arrow-down {
  cursor: pointer;
}
.hide {
  display: none;
}
.el-dropdown-menu {
  width: 9.5rem;
}
.el-dropdown {
  margin-right: 0%;
}
.service-dropdown {
  width: 14rem;
}
.search {
  padding: 12px 23px;
  margin-top: 1px;
  border: none;
  background: #c39a58;
  color: #fff;
}

// 我的代码
.nav-ul {
  display: flex;
  width: 100%;
  .item-nav-ul {
    width: 13%;
  }
  .item-nav-ul-list {
    width: calc(100% - 12% * 2);
    .left-menu {
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/index/main-menu.vue